module.exports = __webpack_public_path__ + "static/media/mapa (1).cc5d3790.jpeg";